import { TextInput, useTranslator, Link } from "@sia/style-guide";
import { useCallback, useContext, useEffect } from "react";
import { WizarContext } from "contexts/WizardContext";
import { corporateSingleMembersActionCreator } from "contexts/WizardContext";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";
import GlobalContext from "contexts/GlobalContext";
import { initialWizardFormState } from "contexts/WizardContext";

function SingleMembers({ errors, setErrors }) {
  const translate = useTranslator();
  const { language } = useContext(GlobalContext);
  const { state, dispatch } = useContext(WizarContext);
  let singleMember = state.corporate.singleMember;
  let singleMembersErrors = errors.corporate.singleMember;
  let changState = useCallback((payload) => dispatch(corporateSingleMembersActionCreator(payload)), [dispatch]);

  const resetInputFieldError = (property, error) => {
    setErrors((errorsState) => ({
      ...errorsState,
      corporate: {
        ...errorsState.corporate,
        singleMember: { ...errorsState.corporate.singleMember, [property]: error },
      },
    }));
  };

  const { user } = useContext(GlobalContext);
  const userId = user.siaId;

  useEffect(() => {
    if (userId) {
      pgAdapter.getWizardSession(({ data }) => {
        const defaultSingleMember = { ...initialWizardFormState.corporate.singleMember };
        const { singleMember } = data?.corporate || {};
        const { siaId, firstname, lastname } = singleMember || defaultSingleMember;
        changState({ siaId, firstname, lastname });
      });
    }
  }, [userId, changState]);

  const setUserSession = (obj) => {
    pgAdapter.getWizardSession(({ data }) => {
      const updatedSession = {
        ...data,
        corporate: { ...(data.corporate || {}), singleMember: { ...(data?.corporate?.singleMember || {}), ...obj } },
      };
      pgAdapter.setWizardSession({ ...updatedSession });
    });
  };
  return (
    <div className="corporate-single-member-page">
      <p className="sia-text-11 sia-padding-04-top">{translate("wizard.form.corporate.singleChoice.lead")}</p>
      <Link className="sia-margin-02-top" target={`/${language}`} withIcon>
        {translate("wizard.form.corporate.singleChoice.link")}
      </Link>
      <p className="sia-padding-02-top sia-text-16">{translate("wizard.form.corporate.singleChoice.info")}</p>
      <p className="sia-text-11 sia-padding-02-top sia-padding-02-bottom">{translate("wizard.form.corporate.singleChoice.sublead")}</p>

      <TextInput
        onBlur={() => {
          setUserSession({ siaId: singleMember.siaId });
        }}
        id={"corporate-single-member-page-siaId"}
        value={singleMember.siaId}
        onChange={(event, value) => {
          resetInputFieldError("siaId");
          changState({ siaId: value });
        }}
        label={translate("wizard.form.corporate.singleChoice.sia-id.label")}
        placeholder={"1234567"}
        required={true}
        invalidPatternText={singleMembersErrors.siaId}
        invalidText={singleMembersErrors.siaId}
      />
      <TextInput
        onBlur={() => {
          setUserSession({ firstname: singleMember.firstname });
        }}
        id={"corporate-single-member-page-firstname"}
        value={singleMember.firstname}
        onChange={(event, value) => {
          resetInputFieldError("firstname");
          changState({ firstname: value });
        }}
        label={translate("wizard.form.corporate.singleChoice.firstname.label")}
        placeholder={translate("idp.register.firstname.placeholder")}
        required={true}
        invalidPatternText={singleMembersErrors.firstname}
        invalidText={singleMembersErrors.firstname}
        />
      <TextInput
        onBlur={() => {
          setUserSession({ lastname: singleMember.lastname });
        }}
        id={"corporate-single-member-page-lastname"}
        value={singleMember.lastname}
        onChange={(event, value) => {
          resetInputFieldError("lastname");
          changState({ lastname: value });
        }}
        label={translate("wizard.form.corporate.singleChoice.lastname.label")}
        placeholder={translate("idp.register.lastname.placeholder")}
        required={true}
        invalidPatternText={singleMembersErrors.lastname}
        invalidText={singleMembersErrors.lastname}
      />
    </div>
  );
}

export default SingleMembers;
